module.exports = __webpack_public_path__ + "img/mz-logo.dae44c93.png";